import { useSupportingDocumentsSubmit } from "@/api/rfs";
import { convertLabelStatusToValue } from "./convertLabelStatusToValue";
import { getResponseMessage } from "@/utils/helper/getErrorMessage";
import { swalError, swalLoading, swalSuccess } from "@/utils/lib/swal";
import { useNavigate } from "react-router-dom";
import { UseFormReturn } from "react-hook-form";
import {
  buildSupportingDocumentPayload,
  SubmitSupportingDocumentsFormSchema,
} from "./useDocumentPrepare";
import { SupportingDocumentField } from "./useCheckingProfileValidations";
import { handleValidationFields } from "./validation";
import { useSupportingDocumentByRfsId } from "@/api/supporting-document";

function useDocumentReject({
  id,
  fields,
  form,
}: {
  id: string;
  fields: SupportingDocumentField[];
  form: UseFormReturn<SubmitSupportingDocumentsFormSchema>;
}) {
  const navigate = useNavigate();
  const { mutate: submit } = useSupportingDocumentsSubmit();
  const { data: supportingDocument } = useSupportingDocumentByRfsId({
    rfsId: id,
  });

  function handleReject(values: SubmitSupportingDocumentsFormSchema) {
    // Validasi field yang diperlukan terlebih dahulu
    const isValidationPassed = handleValidationFields(
      values,
      fields,
      form,
      supportingDocument,
      true,
    );
    // Jika validasi gagal, hentikan proses submit
    if (!isValidationPassed) {
      return;
    }

    if (values.statusFeederAndOlt === "OLS - Feeder Done") {
      values.statusFeederAndOlt = "OLS_DONE_FEEDER";
    } else {
      values.statusFeederAndOlt = convertLabelStatusToValue(
        values.statusFeederAndOlt,
      );
    }

    swalLoading.fire();
    submit(
      {
        id,
        data: {
          supportingDocument: buildSupportingDocumentPayload(
            values,
            supportingDocument,
          ),
        },
        params: {
          decision: "no",
          withVariable: "true",
        },
      },
      {
        onSuccess: () => {
          swalSuccess.fire({
            text: "RFS Submission process is successful.",
          });
        },
        onError: (error) => {
          swalError.fire({
            text: getResponseMessage(
              error,
              "RFS Submission process is failed.",
            ),
          });
        },
        onSettled: () => navigate(0),
      },
    );
  }

  return {
    handleReject,
  };
}

export type { SubmitSupportingDocumentsFormSchema };
export { useDocumentReject };
